import React from 'react';

const Head = () => (
  <thead>
    <tr>
      <th className="p-l hide-services-table__id">ID</th>
      <th>Hidden services</th>
      <th>{' '}</th>
    </tr>
  </thead>
);

Head.propTypes = {

};

export default Head;
